import React from 'react';
import useCopy from '../../hooks/useCopy';
import copyPDFjs from '../../copy/pdf-sdk';
import PPCLandingPage from '../../templates/PPCLandingPageTemplate/PPCLandingPageTemplate';

export default function PDFSDK () {
  const copy = useCopy(copyPDFjs)
  return (
    <PPCLandingPage copy={copy}/>
  );
}